import {
  ROUTE_REWARDS_LEADERBOARD,
  ROUTE_REWARDS_POTENTIAL,
  ROUTE_REWARDS_WON,
} from "Consts/publicRoutes";

export const SIDENAV_REWARDS_SECTION = {
  text: "Rewards",
  userRoute: ROUTE_REWARDS_WON,
  restrictedRoute: "",
};

export const SIDENAV_REWARDS_WON_ROUTE = {
  route: { name: ROUTE_REWARDS_WON },
  text: "Won",
};

export const SIDENAV_REWARDS_LEADERBOARD_ROUTE = {
  route: { name: ROUTE_REWARDS_LEADERBOARD },
  text: "Leaderboard",
};

export const SIDENAV_REWARDS_POTENTIAL_ROUTE = {
  route: { name: ROUTE_REWARDS_POTENTIAL },
  text: "Potential",
};
